export default __webpack_public_path__ + "static/media/verify-account-enter-code.2f39ef1f.svg";